import { lazy, Suspense } from 'react';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';

const AIAssistantChatWindow = lazy(() => import('components/editor/AiAssistant/AIAssistantChatWindow'));

export default function AIAssistantWrapper({ contentId }: { contentId: string }) {
  const sections = useAppSelector((state) => state.gridBlockReducer.sections);

  return (
    <div style={{ position: 'absolute', inset: 0, minHeight: 0 }}>
      <Suspense fallback={null}>
        <AIAssistantChatWindow contentId={contentId} sectionId={sections.at(sections.length - 1)?.id ?? ''} />
      </Suspense>
    </div>
  );
}
